import React from 'react';

const ServiceArea = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Serving the Entire United States
          </h2>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
            ATW Against the Wind Moving Services operates nationwide, providing flexible and reliable moving solutions
            from coast to coast. No matter where you're headed, we have the experience and resources to get you there
            safely and on time.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServiceArea;